import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Footer } from "@/components/Footer";

const About = () => {
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      console.log("Fetching about page content");
      const { data, error } = await supabase
        .from('site_content')
        .select('content')
        .eq('key', 'about_text')
        .maybeSingle();

      if (error) {
        console.error("Error fetching about content:", error);
      }

      if (data) {
        setContent(data.content);
      }
      setIsLoading(false);
    };

    fetchContent();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#1a1c2e] to-[#2d1b4b] py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="animate-pulse">
              <div className="h-8 bg-white/10 rounded w-48 mb-8"></div>
              <div className="space-y-4">
                <div className="h-4 bg-white/5 rounded w-full"></div>
                <div className="h-4 bg-white/5 rounded w-5/6"></div>
                <div className="h-4 bg-white/5 rounded w-4/6"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a1c2e] to-[#2d1b4b]">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-8">关于我们</h1>
          <div className="bg-white/5 backdrop-blur-lg rounded-lg p-8 text-gray-300 leading-relaxed shadow-xl border border-white/10">
            <div className="prose prose-invert max-w-none">
              {content.split('\n').map((paragraph, index) => (
                <p key={index} className="mb-4">{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;